import {
    IProps,
    IRef,
} from './types';

import classNames from 'classnames';
import React, {
    forwardRef,
    useImperativeHandle,
    useRef,
} from 'react';

import AuthInfo from './AuthInfo';
import Navigation from './Navigation';
import NavigationMobile from './NavigationMobile';

import logoImage from './media/logo.svg';

import styles from './Header.module.scss';

const Header = forwardRef<IRef, IProps>((props, ref) => {
    const headerRef = useRef<HTMLElement>(null);

    useImperativeHandle(ref, () => {
        return {
            getHeight(): number {
                return headerRef.current?.clientHeight ?? 0;
            },
        };
    });

    return (
        <header
            ref={headerRef}
            className={classNames(styles.header, props.className)}
        >
            <div className={styles.left}>
                <NavigationMobile className={styles.navigationMobile}/>
                <div className={styles.logo}>
                    <img
                        className={styles.logoMark}
                        src={logoImage}
                        alt={''}
                    />
                    <span className={styles.logoText}>martix</span>
                </div>
                <Navigation className={styles.navigation}/>
            </div>
            <AuthInfo/>
        </header>
    );
});

export default Header;
